import React,
{
    useState
}
from "react";

import
{
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import
{
    faTimes
}
from "@fortawesome/free-solid-svg-icons";

import BuildingBookAssetGeneral
    from "./BuildingBookAssetGeneral";

import BuildingBookAssetPhotos
    from "./BuildingBookAssetPhotos";

import BuildingBookAssetDocuments
    from "./BuildingBookAssetDocuments";

import BuildingBookAssetCondition
    from "./BuildingBookAssetCondition";

import BuildingBookAssetCompliance
    from "./BuildingBookAssetCompliance";


export default function BuildingBookAssetDetailsPanel(
{
    selectedAsset,
    setDetailsOpen
})
{
    const [selectedTab,
        setSelectedTab] =
            useState("General");



    if(!selectedAsset)
    {
        return null;
    }



    return (

        <div style={container}>

            <div style={header}>

                <div>

                    <div style={assetCode}>
                        {selectedAsset.code}
                    </div>

                    <div style={assetName}>
                        {selectedAsset.name}
                    </div>

                </div>

                <FontAwesomeIcon
                    icon={faTimes}
                    style={closeIcon}
                    onClick={
                        function()
                        {
                            setDetailsOpen(false);
                        }
                    }
                />

            </div>



            <div style={tabContainer}>

                <TabButton
                    label="General"
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                />

                <TabButton
                    label="Photos"
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                />

                <TabButton
                    label="Documents"
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                />

                <TabButton
                    label="Condition"
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                />

                <TabButton
                    label="Compliance"
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                />


            </div>



            <div style={content}>

                {
                    selectedTab === "General"
                    &&
                    <BuildingBookAssetGeneral
                        asset={selectedAsset}
                    />
                }

                {
                    selectedTab === "Photos"
                    &&
                    <BuildingBookAssetPhotos
                        asset={selectedAsset}
                    />
                }

                {
                    selectedTab === "Documents"
                    &&
                    <BuildingBookAssetDocuments
                        asset={selectedAsset}
                    />
                }

                {
                    selectedTab === "Condition"
                    &&
                    <BuildingBookAssetCondition
                        asset={selectedAsset}
                    />
                }

                {
                    selectedTab === "Compliance"
                    &&
                    <BuildingBookAssetCompliance
                        asset={selectedAsset}
                    />
                }


            </div>

        </div>

    );
}



function TabButton(
{
    label,
    selectedTab,
    setSelectedTab
})
{
    const selected =
        selectedTab === label;

    return (

        <div
            style={
            {
                ...tabButton,

                background:
                    selected
                    ?
                    "linear-gradient(180deg,#5a9bd6 0%,#417fb7 100%)"
                    :
                    "#f4f6f8",

                color:
                    selected
                    ?
                    "#fff"
                    :
                    "#444"
            }}
            onClick={
                function()
                {
                    setSelectedTab(label);
                }
            }
        >

            {label}

        </div>

    );
}



const container =
{
    display: "flex",

    flexDirection: "column",

    width: "100%",

    height: "100%",

    background: "#ffffff"
};



const header =
{
    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    padding: "20px 24px",

    borderBottom:
        "1px solid #e5e7eb"
};



const assetCode =
{
    fontSize: "24px",

    fontWeight: "700",

    color: "#222"
};



const assetName =
{
    fontSize: "13px",

    color: "#777",

    marginTop: "4px"
};



const closeIcon =
{
    fontSize: "20px",

    cursor: "pointer",

    color: "#666"
};



const tabContainer =
{
    display: "flex",

    gap: "10px",

    padding: "16px 24px",

    borderBottom:
        "1px solid #e5e7eb"
};



const tabButton =
{
    padding: "10px 18px",

    borderRadius: "20px",

    cursor: "pointer",

    fontSize: "13px",

    fontWeight: "600",

    transition: "all 0.2s ease"
};



const content =
{
    flex: 1,

    overflowY: "auto",

    padding: "24px"
};